<template>
  <BaseListItem>
    <div class="flex -mx-4 text-sm p-4">
      <div class="w-16 flex-none pl-3">
        <RouterLink
          :to="{ name: 'accounts.show', params: { accountId: relatedAccount.id } }"
          class="capitalize"
        >
          <template v-if="relatedAccount && relatedAccount.logo">
            <img :src="relatedAccount.logo" class="block rounded w-full" />
          </template>
          <template v-else>
            <div class="aspect-ratio-square w-full rounded bg-gray-200" />
          </template>
        </RouterLink>
      </div>
      <div class="flex-1 px-3">
        <div>
          <div class="flex -mx-3">
            <div class="flex-1 flex flex-col justify-start px-3 space-y-2">
              <div>
                <RouterLink v-if="salesOrder.can.view" :to="to" class="block">
                  {{ salesOrder.name }}
                </RouterLink>
                <span v-else>{{ salesOrder.name }}</span>
                <span class="text-gray-700 text-xs">{{ supplier.name }}</span>
              </div>
              <ul class="flex flex-wrap space-x-1">
                <li v-for="tag in tags" :key="tag.id">
                  <BaseBadge
                    custom
                    :style="{
                      backgroundColor: tag.customProperties.background,
                      color: tag.customProperties.color,
                    }"
                    class="whitespace-nowrap"
                  >
                    {{ tag.name }}
                  </BaseBadge>
                </li>
              </ul>
            </div>
            <div class="w-32 px-3">
              <BaseBadge silver>
                {{ status.name }}
              </BaseBadge>
            </div>
            <div class="w-32 px-3">
              <BaseBadge v-if="salesOrder.projectsCount" green> In project </BaseBadge>
            </div>
            <div class="w-32 px-3">
              <BaseBadge v-if="salesOrder.invoice" green> Has Invoice </BaseBadge>
            </div>
            <div class="w-32 px-3 text-right">{{ salesOrder.price }} &euro;</div>
            <div class="w-32 px-3 text-right text-xs">
              {{ salesOrder.deliveryAtForHumans }}
            </div>
            <div class="w-32 px-3 text-right text-xs">
              {{ salesOrder.createdAtForHumans }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </BaseListItem>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    salesOrder: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('entities', {
      client(state) {
        return state.accountRelations.byId[this.salesOrder.clientUuid] || null;
      },
      relatedAccount(state) {
        if (!this.client) return null;
        if (!this.client.related_account_uuid) return null;
        return state.accounts.byId[this.client.related_account_uuid] || null;
      },
      supplier(state) {
        return state.accounts.byId[this.salesOrder.supplierUuid] || null;
      },
      status(state) {
        return state.orderStatuses.byId[this.salesOrder.statusId] || null;
      },
      tags(state) {
        return this.salesOrder.tags.map((id) => state.orderTags.byId[id]);
      },
    }),
    to() {
      const { type, accountUuid, uuid } = this.salesOrder;
      const { id: accountId } = this.relatedAccount || { related_account_uuid: accountUuid };

      if (type === 'production') {
        return {
          name: 'accounts.productionOrders.productionOrderUuid',
          params: { accountId, productionOrderUuid: uuid },
        };
      }
      return {
        name: 'accounts.orders.show',
        params: { accountId, orderId: uuid },
      };
    },
  },
};
</script>
